import ListAssets from './ListAssets'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
    container: {
        //height: "91vh",
        marginTop: 100
    }
})

export default function ManageAssets() {

    const classes = useStyles()

    return (
        <Grid container className={classes.container}>
            
            {/* <Grid container justify={'flex-end'}>
                <CreateAssetButton />
            </Grid> */}

            <Grid container xs={12}>
                <ListAssets />
            </Grid>
        
        </Grid>
    )
}